import { useEffect, useState } from "react";
import * as authService from "../services/auth-service";
import { LoginUser } from "../pages/login/model";
import { NewUser } from "../pages/signup/model";
import { City } from "./models/City";

export const useSignupUser = () => {
    const createUser = async (user: NewUser): Promise<void> => {
        await authService.signup(user);
    };
    return { createUser };
};

export const useLoginUser = () => {
    const loginUser = async (user: LoginUser): Promise<{ token: string }> => {
        return await authService.login(user);
    };
    return { loginUser };
};

export const useVerifyEmail = () => {
    const verifyEmail = async (code: string): Promise<{ token: string }> => {
        return await authService.verifyEmail(code);
    };
    return { verifyEmail };
};

export const useResendVerificationEmail = () => {
    const resendEmail = async (email: string): Promise<void> => {
        await authService.resendVerificationEmail(email);
    };
    return { resendEmail };
};

export const useGetCities = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [cities, setCities] = useState<Array<City>>([]);

    useEffect(() => {
        authService.getCities()
            .then((data: Array<City>) => {
                setCities(data);
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    }, []);

    return { cities, isLoading };
};